import React from 'react';
import FormLead from './FormLead';

const CreateLead: React.FC = function CreateLead() {
  return <FormLead />;
};

export default CreateLead;
